<template>
  <div class="grid is-col-min-15"
    :class="{ 'quote-remarks-licence-expired': $licenceExpired }">
    <div class="cell is-flex is-flex-direction-column grid mb-0">
      <div class="is-flex-grow-1 is-flex cell">
        <article class="box is-flex-grow-1">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Remarks</p>
            </div>
            <div class="column">
              <div class="field">
                <div class="is-pulled-right">
                  <div class="is-pulled-right">
                    <a class="button is-small is-success tooltip is-tooltip-bottom"
                      :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Add Remarks'"
                      :disabled="$licenceExpired"
                      @click="toggleRemarkModal()">
                      <span class="icon">
                        <i class="mdi mdi-18px mdi-plus" />
                      </span>
                      <span>Remarks</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
            :columns="columns"
            :page-index="filter.pageIndex"
            :page-size="filter.pageSize"
            :total-rows="remarkTotalRows"
            :is-loading="isTableLoading"
            :sort-column="filter.sortColumn"
            :sort-order="filter.sortOrder"
            :show-header="false"
            @pageChanged="onPageChange"
            @sort="sort">
            <tr v-for="(remark, index) in pagedRemarks"
              :key="remark.remarkId"
              @click="highlightSelected(index, $event)">
              <td>
                <!-- <div class="is-pulled-left">
                </div> -->
                <div class="is-pulled-left ml-1">
                  <div v-show="editRemarkRowNumber === -1 || editRemarkRowNumber !== index">{{ remark.remarks }}</div>
                  <textarea v-if="editRemarkRowNumber === index"
                    class="textarea"
                    v-model="editRemarkInnerValue"
                    rows="3"
                    v-focus-inserted />
                </div>
                <div class="is-clearfix" />
                <div class="is-flex is-align-items-center is-size-7">
                  <user-profile-icon v-if="remark.firstName || remark.displayName"
                    :is-text-profile="true"
                    :first-name="remark.firstName"
                    :last-name="remark.lastName"
                    :display-name="remark.displayName"
                    :width="20"
                    :height="20"
                    class="pr-1" />
                  <span class="is-italic pr-1">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                  <span class="is-rounded is-success tag is-italic"
                    v-if="remark.isSyncRepX">
                    <i class="mdi mdi-check mdi-14px" />  RepX
                  </span>
                </div>
              </td>
              <td class="is-content-width">
                <a class="button is-danger is-small is-inverted"
                  :disabled="$licenceExpired"
                  @click="setPinRemarkOrder(remark)">
                  <span class="icon is-medium">
                    <i class="mdi mdi-22px"
                      :class="[remark.pinRemarkOrder !== null ? 'mdi-pin' : 'mdi-pin-outline']" />
                  </span>
                </a>
                <a v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="button is-primary is-small is-inverted"
                  :disabled="$licenceExpired"
                  @mousedown="editRemark(index, remark)">
                  <span class="icon is-medium">
                    <i class="mdi mdi-24px"
                      :class="[editRemarkRowNumber !== index ? 'mdi-lead-pencil' : 'mdi-check']" />
                  </span>
                </a>
                <a v-if="editRemarkRowNumber === index"
                  class="button is-danger is-small is-inverted"
                  @click="cancelEditRemark()">
                  <span class="icon is-medium">
                    <i class="mdi mdi-close mdi-24px" />
                  </span>
                </a>
                <a v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="button is-danger is-small is-inverted"
                  :disabled="$licenceExpired"
                  @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                  <span class="icon is-medium">
                    <i class="mdi mdi-delete mdi-24px" />
                  </span>
                </a>
              </td>
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </article>
      </div>
      <div v-show="innerValue.dueInNotes.length !== 0"
        class="cell">
        <article class="box">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Due In Notes</p>
            </div>
          </div>
          <div class="field">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="dueInFilter.pageIndex"
              :page-size="dueInFilter.pageSize"
              :total-rows="dueInNotesTotalRows"
              :is-loading="isTableLoading"
              :sort-column="dueInFilter.sortColumn"
              :sort-order="dueInFilter.sortOrder"
              :show-header="false"
              @pageChanged="onDueInNotePageChange"
              @sort="sort">
              <tr v-for="(remark, index) in pagedDueInNotes"
                :key="remark.remarkId"
                @click="highlightSelected(index, $event)">
                <td>
                  <div class="is-pulled-left ml-1">
                    <div v-show="editDueInNoteRowNumber === -1 || editDueInNoteRowNumber !== index">{{ remark.remarks }}</div>
                    <textarea v-if="editDueInNoteRowNumber === index"
                      class="textarea"
                      v-model="editDueInNoteInnerValue"
                      rows="3"
                      v-focus-inserted />
                  </div>
                  <div class="is-clearfix" />
                  <div class="is-flex is-align-items-center is-size-7">
                    <user-profile-icon v-if="remark.firstName || remark.displayName"
                      :is-text-profile="true"
                      :first-name="remark.firstName"
                      :last-name="remark.lastName"
                      :display-name="remark.displayName"
                      :width="20"
                      :height="20"
                      class="pr-1" />
                    <span class="is-italic">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                  </div>
                </td>
                <td v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="is-content-width">
                  <a class="button is-primary is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="editDueInNote(index, remark)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-24px"
                        :class="[editDueInNoteRowNumber !== index ? 'mdi-lead-pencil' : 'mdi-check']" />
                    </span>
                  </a>
                  <a v-if="editDueInNoteRowNumber === index"
                    class="button is-danger is-small is-inverted"
                    @click="cancelEditDueInNote()">
                    <span class="icon is-medium">
                      <i class="mdi mdi-close mdi-24px" />
                    </span>
                  </a>
                  <a class="button is-danger is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-delete mdi-24px" />
                    </span>
                  </a>
                </td>
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </div>
        </article>
      </div>
      <div v-show="innerValue.dueOutNotes.length !== 0"
        class="cell">
        <article class="box">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Due Out Notes</p>
            </div>
          </div>
          <div class="field">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="dueOutFilter.pageIndex"
              :page-size="dueOutFilter.pageSize"
              :total-rows="dueOutNotesTotalRows"
              :is-loading="isTableLoading"
              :sort-column="dueOutFilter.sortColumn"
              :sort-order="dueOutFilter.sortOrder"
              :show-header="false"
              @pageChanged="onDueOutNotePageChange"
              @sort="sort">
              <tr v-for="(remark, index) in pagedDueOutNotes"
                :key="remark.remarkId"
                @click="highlightSelected(index, $event)">
                <td>
                  <div class="is-pulled-left ml-1">
                    <div v-show="editDueOutNoteRowNumber === -1 || editDueOutNoteRowNumber !== index">{{ remark.remarks }}</div>
                    <textarea v-if="editDueOutNoteRowNumber === index"
                      class="textarea"
                      v-model="editDueOutNoteInnerValue"
                      rows="3"
                      v-focus-inserted />
                  </div>
                  <div class="is-clearfix" />
                  <div class="is-flex is-align-items-center is-size-7">
                    <user-profile-icon v-if="remark.firstName || remark.displayName"
                      :is-text-profile="true"
                      :first-name="remark.firstName"
                      :last-name="remark.lastName"
                      :display-name="remark.displayName"
                      :width="20"
                      :height="20"
                      class="pr-1" />
                    <span class="is-italic">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                  </div>
                </td>
                <td v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="is-content-width">
                  <a class="button is-primary is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="editDueOutNote(index, remark)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-24px"
                        :class="[editDueOutNoteRowNumber !== index ? 'mdi-lead-pencil' : 'mdi-check']" />
                    </span>
                  </a>
                  <a v-if="editDueOutNoteRowNumber === index"
                    class="button is-danger is-small is-inverted"
                    @click="cancelEditDueOutNote()">
                    <span class="icon is-medium">
                      <i class="mdi mdi-close mdi-24px" />
                    </span>
                  </a>
                  <a class="button is-danger is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-delete mdi-24px" />
                    </span>
                  </a>
                </td>
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </div>
        </article>
      </div>
    </div>
    <div class="cell is-flex is-flex-direction-column grid">
      <div class="cell">
        <article class="box">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Printed Remarks</p>
            </div>
            <div class="column">
              <div class="field">
                <div class="is-pulled-right">
                  <div class="is-pulled-right">
                    <button class="button is-small is-success tooltip is-tooltip-left"
                      :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Add Remarks'"
                      :disabled="$licenceExpired"
                      @click="toggleRemarkModal()">
                      <span class="icon">
                        <i class="mdi mdi-18px mdi-plus" />
                      </span>
                      <span>Remarks</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="printedFilter.pageIndex"
              :page-size="printedFilter.pageSize"
              :total-rows="printedRemarkTotalRows"
              :is-loading="isTableLoading"
              :sort-column="printedFilter.sortColumn"
              :sort-order="printedFilter.sortOrder"
              :show-header="false"
              @pageChanged="onPrintedRemarksPageChange"
              @sort="sort">
              <tr v-for="(remark, index) in pagedPrintedRemarks"
                :key="remark.remarkId">
                <td class="is-remark">
                  <div v-show="editPrintedRemarkRowNumber === -1 || editPrintedRemarkRowNumber !== index">{{ remark.remarks }}</div>
                  <textarea v-if="editPrintedRemarkRowNumber === index"
                    class="textarea"
                    v-model="editPrintedRemarkInnerValue"
                    rows="3"
                    v-focus-inserted />
                  <div class="is-flex is-align-items-center is-size-7">
                    <user-profile-icon v-if="remark.firstName || remark.displayName"
                      :is-text-profile="true"
                      :first-name="remark.firstName"
                      :last-name="remark.lastName"
                      :display-name="remark.displayName"
                      :width="20"
                      :height="20"
                      class="pr-1" />
                    <span class="is-italic">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                  </div>
                </td>
                <td v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="has-text-centered is-content-width has-vertical-middle">
                  <a class="button is-primary is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="editPrintedRemark(index, remark)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-24px"
                        :class="[editPrintedRemarkRowNumber !== index ? 'mdi-lead-pencil' : 'mdi-check']" />
                    </span>
                  </a>
                  <a v-if="editPrintedRemarkRowNumber === index"
                    class="button is-danger is-small is-inverted"
                    @click="cancelEditPrintedRemark()">
                    <span class="icon is-medium">
                      <i class="mdi mdi-close mdi-24px" />
                    </span>
                  </a>
                  <a class="button is-danger is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-delete mdi-24px" />
                    </span>
                  </a>
                </td>
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </div>
        </article>
      </div>
      <div v-if="showJobNoteRemarks"
        class="cell">
        <article class="box">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Job Remarks</p>
            </div>
            <div class="column">
              <div class="field">
                <div class="is-pulled-right">
                  <div class="is-pulled-right">
                    <button class="button is-small is-success tooltip is-tooltip-left"
                      :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Add Remarks'"
                      :disabled="$licenceExpired"
                      @click="toggleRemarkModal()">
                      <span class="icon">
                        <i class="mdi mdi-18px mdi-plus" />
                      </span>
                      <span>Remarks</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="jobFilter.pageIndex"
              :page-size="jobFilter.pageSize"
              :total-rows="jobRemarkTotalRows"
              :is-loading="isTableLoading"
              :sort-column="jobFilter.sortColumn"
              :sort-order="jobFilter.sortOrder"
              :show-header="false"
              @pageChanged="onJobNoteRemarksPageChange"
              @sort="sort">
              <tr v-for="(remark, index) in pagedJobNoteRemarks"
                :key="remark.remarkId">
                <td class="is-remark">
                  <div v-show="editJobNoteRemarkRowNumber === -1 || editJobNoteRemarkRowNumber !== index">{{ remark.remarks }}</div>
                  <textarea v-if="editJobNoteRemarkRowNumber === index"
                    class="textarea"
                    v-model="editJobNoteRemarkInnerValue"
                    rows="3"
                    v-focus-inserted />
                  <div class="is-flex is-align-items-center is-size-7">
                    <user-profile-icon v-if="remark.firstName || remark.displayName"
                      :is-text-profile="true"
                      :first-name="remark.firstName"
                      :last-name="remark.lastName"
                      :display-name="remark.displayName"
                      :width="20"
                      :height="20"
                      class="pr-1" />
                    <span class="is-italic">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                  </div>
                </td>
                <td v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                  class="has-text-centered is-content-width has-vertical-middle">
                  <a class="button is-primary is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="editJobNoteRemark(index, remark)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-24px"
                        :class="[editJobNoteRemarkRowNumber !== index ? 'mdi-lead-pencil' : 'mdi-check']" />
                    </span>
                  </a>
                  <a v-if="editJobNoteRemarkRowNumber === index"
                    class="button is-danger is-small is-inverted"
                    @click="cancelEditJobNoteRemark()">
                    <span class="icon is-medium">
                      <i class="mdi mdi-close mdi-24px" />
                    </span>
                  </a>
                  <a class="button is-danger is-small is-inverted"
                    :disabled="$licenceExpired"
                    @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                    <span class="icon is-medium">
                      <i class="mdi mdi-delete mdi-24px" />
                    </span>
                  </a>
                </td>
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </div>
        </article>
      </div>
      <div class="cell">
        <article class="box">
          <div class="columns is-gapless">
            <div class="column">
              <p class="title">Other Remarks</p>
            </div>
            <div class="column">
              <div class="field">
                <div class="control is-pulled-right">
                  <div class="is-pulled-right">
                    <div class="select">
                      <select v-model="otherRemarksIdFilter">
                        <option :value="0">All</option>
                        <option v-for="remark in formattedRemarkTypes"
                          :key="remark.value"
                          :value="remark.value">{{ remark.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
            :columns="columns"
            :page-index="otherFilter.pageIndex"
            :page-size="otherFilter.pageSize"
            :total-rows="otherRemarkTotalRows"
            :is-loading="isTableLoading"
            :sort-column="otherFilter.sortColumn"
            :sort-order="otherFilter.sortOrder"
            :show-header="false"
            @pageChanged="onOtherRemarksPageChange"
            @sort="sort">
            <tr v-for="(remark, index) in pagedOtherRemarks"
              :key="remark.remarkId">
              <td class="is-remark">
                <div v-html="remark.remarks.replaceAll('\n', '<br>')" />
                <div class="is-flex is-align-items-center is-size-7">
                  <span class="is-italic">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
                </div>
              </td>
              <td v-if="$user.info.isSupportUser || $user.info.isCustomerAdministrator"
                class="has-text-centered is-content-width has-vertical-middle">
                <a class="button is-danger is-small is-inverted"
                  :disabled="$licenceExpired"
                  @click="deleteRemark(index, remark.remarkId, remark.remarkTypeId)">
                  <span class="icon is-medium">
                    <i class="mdi mdi-delete mdi-24px" />
                  </span>
                </a>
              </td>
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </article>
      </div>
      <quote-incident-notes
        :value="innerValue.incidentNotes"
        :is-saving="isIncidentNotesSaving"
        :disabled="$licenceExpired"
        @text-change="onIncidentNotesTextChange"
        @date-change="onIncidentNotesDateChange"
        @notes-blur="onIncidentNotesSave"
        @date-save="onIncidentNotesSave"
      />
    </div>

    <remark-modal v-if="value && isRemarkModalActive"
      :show-remark="true"
      :show-printed-remark="true"
      :show-job-note-remark="true"
      :show-recurring-remark="true"
      :active.sync="isRemarkModalActive"
      @add="addRemarks"
      @cancel="toggleRemarkModal()">
      <p slot="text-title">Add Quote Remarks</p>
      <div slot="remark-last-postfix"
        class="is-flex ml-6"
        v-if="!!value.repx">
        <bulma-checkbox v-model="value.isSyncRepX" />
        <div>
          <small>Sync to RepX</small>
        </div>
      </div>
    </remark-modal>
  </div>
</template>

<script>
import { DateTimeFiltersMixin, NumberFiltersMixin } from '@/components/mixins/filters'
import { RemarkModal } from '@/components/BulmaModal'
import { EventHubTypes, ExternalSettingTypes, RemarkTypes } from '@/enums'
import { RemarkColumns } from './columns'
import BulmaTable from '@/components/BulmaTable'
import { FocusInserted } from '@/components/directives'
import UserProfileIcon from '@/components/UserProfileIcon/UserProfileIcon'
import { RemarkModel } from '@/classes/viewmodels'
import _startCase from 'lodash.startcase'
import { CompanySettingService } from '@/services'
import RemarkService from '@/services/RemarkService'
import BulmaCheckbox from '@/components/BulmaCheckbox/BulmaCheckbox.vue'
import { createQuoteRemarksAutoSaveHelper } from './helpers/QuoteRemarksAutoSaveHelper'
import QuoteIncidentNotes from './components/QuoteRemarks/QuoteIncidentNotes'

export default {
  name: 'QuoteRemarks',
  directives: {
    FocusInserted
  },
  components: {
    RemarkModal,
    BulmaTable,
    UserProfileIcon,
    BulmaCheckbox,
    QuoteIncidentNotes
  },
  mixins: [DateTimeFiltersMixin, NumberFiltersMixin],
  props: {
    value: null,
    autoSaveEnabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerValue: null,
      isRemarkModalActive: false,
      isIncidentNotesSaving: false,
      selectedRow: null,
      isTableLoading: false,
      filter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 15
      },
      printedFilter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 6
      },
      jobFilter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 6
      },
      otherFilter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 6
      },
      dueInFilter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 4
      },
      dueOutFilter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 4
      },
      editRemarkRowNumber: -1,
      editPrintedRemarkRowNumber: -1,
      editJobNoteRemarkRowNumber: -1,
      editDueInNoteRowNumber: -1,
      editDueOutNoteRowNumber: -1,
      editRemarkInnerValue: '',
      editPrintedRemarkInnerValue: '',
      editJobNoteRemarkInnerValue: '',
      editDueInNoteInnerValue: '',
      editDueOutNoteInnerValue: '',
      otherRemarkTypes: {
        //subset or RemarkTypes.js
        ORMSystemRemark: 19,
        PNETSystemRemark: 20,
        OtherSystemRemark: 21,
        ORMMessageRemark: 22,
        PNETMessageRemark: 23,
        REPXSystemRemark: 30,
        PartsCheckRemark: 35
      },
      otherRemarksIdFilter: 0,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ],
      showJobNoteRemarks: false
    }
  },
  computed: {
    columns() {
      return RemarkColumns
    },
    remarkTypes() {
      return RemarkTypes
    },
    remarkTotalRows() {
      return this.innerValue.remarks.filter((r) => r.remarkTypeId === RemarkTypes.Remark && !r.isDeleted).length
    },
    printedRemarkTotalRows() {
      return this.innerValue.printedRemarks.filter((r) => r.remarkTypeId === RemarkTypes.PrintedRemark && !r.isDeleted).length
    },
    jobRemarkTotalRows() {
      return this.innerValue.jobNoteRemarks.filter((r) => r.remarkTypeId === RemarkTypes.JobNote && !r.isDeleted).length
    },
    otherRemarkTotalRows() {
      if (!this.otherRemarksIdFilter) {
        return this.innerValue.otherRemarks.filter((r) => !r.isDeleted).length
      } else {
        return this.innerValue.otherRemarks.filter((r) => !r.isDeleted && r.remarkTypeId === this.otherRemarksIdFilter).length
      }
    },
    dueInNotesTotalRows() {
      return this.innerValue.dueInNotes.filter((r) => !r.isDeleted).length
    },
    dueOutNotesTotalRows() {
      return this.innerValue.dueOutNotes.filter((r) => !r.isDeleted).length
    },
    pagedRemarks() {
      return this.activeRemarks.slice((this.filter.pageIndex - 1) * this.filter.pageSize, this.filter.pageIndex * this.filter.pageSize)
    },
    pagedPrintedRemarks() {
      return this.activePrintedRemarks.slice(
        (this.printedFilter.pageIndex - 1) * this.printedFilter.pageSize,
        this.printedFilter.pageIndex * this.printedFilter.pageSize
      )
    },
    pagedJobNoteRemarks() {
      return this.activeJobNoteRemarks.slice(
        (this.jobFilter.pageIndex - 1) * this.jobFilter.pageSize,
        this.jobFilter.pageIndex * this.jobFilter.pageSize
      )
    },
    pagedOtherRemarks() {
      return this.activeOtherRemarks.slice((this.otherFilter.pageIndex - 1) * this.otherFilter.pageSize, this.otherFilter.pageIndex * this.otherFilter.pageSize)
    },
    pagedDueInNotes() {
      return this.activeDueInNotes.slice((this.dueInFilter.pageIndex - 1) * this.dueInFilter.pageSize, this.dueInFilter.pageIndex * this.dueInFilter.pageSize)
    },
    pagedDueOutNotes() {
      return this.activeDueOutNotes.slice((this.dueOutFilter.pageIndex - 1) * this.dueOutFilter.pageSize, this.dueOutFilter.pageIndex * this.dueOutFilter.pageSize)
    },
    activeRemarks() {
      const pinnedActiveRemarks = this.innerValue.remarks.filter(
        r => r.pinRemarkOrder != null && r.remarkTypeId === RemarkTypes.Remark && !r.isDeleted)
      const unpinnedActiveRemarks = this.innerValue.remarks.filter(
        r => r.pinRemarkOrder == null && r.remarkTypeId === RemarkTypes.Remark && !r.isDeleted)
      pinnedActiveRemarks.sort(function (a, b) {
        return a.pinRemarkOrder - b.pinRemarkOrder
      })
      unpinnedActiveRemarks.sort(function (a, b) {
        return new Date(b.remarkDateTime) - new Date(a.remarkDateTime)
      })
      return [...pinnedActiveRemarks, ...unpinnedActiveRemarks]
    },
    activePrintedRemarks() {
      return this.innerValue.printedRemarks.filter((r) => r.remarkTypeId === RemarkTypes.PrintedRemark && !r.isDeleted)
    },
    activeJobNoteRemarks() {
      return this.innerValue.jobNoteRemarks.filter(
        (r) => r.remarkTypeId === RemarkTypes.JobNote && !r.isDeleted).sort((a, b) => {
        return new Date(b.remarkDateTime) - new Date(a.remarkDateTime)
      })
    },
    activeOtherRemarks() {
      if (!this.otherRemarksIdFilter) {
        return this.innerValue.otherRemarks.filter((r) => !r.isDeleted)
      } else {
        return this.innerValue.otherRemarks.filter((r) => !r.isDeleted && r.remarkTypeId === this.otherRemarksIdFilter)
      }
    },
    activeDueInNotes() {
      return this.innerValue.dueInNotes.filter((r) => r.remarkTypeId === RemarkTypes.DueInNote && !r.isDeleted)
    },
    activeDueOutNotes() {
      return this.innerValue.dueOutNotes.filter((r) => r.remarkTypeId === RemarkTypes.DueOutNote && !r.isDeleted)
    },
    formattedRemarkTypes() {
      return Object.entries(this.otherRemarkTypes).map(([prop, value]) => {
        return {
          label: prop === 'PartsCheckRemark' ? 'PartsCheck Remark' : this.startCase(prop),
          value: value
        }
      })
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    }
  },
  async created() {
    this.innerValue = this.value
    if (this.autoSaveEnabled) {
      this._remarksAutoSaveHelper = createQuoteRemarksAutoSaveHelper((isSaving) => {
        this.$emit('remarks-save-state-change', isSaving)
        if (!isSaving) this.$emit('remarks-saved')
      })
    }
    await this.getPlanningPlusActiveStatus()
    this.setRemarksAsRead()
  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.EntityReloaded, () => {
      this.innerValue = this.value
    })
  },
  beforeDestroy() {
    this.$eventHub.$off(EventHubTypes.EntityReloaded)
  },
  methods: {
    // Opening the tab is the read action - there is no explicit "mark as read" control,
    // by design. The dot is cleared straight away rather than on the sub nav's next poll;
    // a failure here is not worth interrupting the user for, since the next poll corrects it.
    async setRemarksAsRead() {
      const quoteId = this.innerValue && this.innerValue.quoteId
      if (!quoteId) return
      try {
        await RemarkService.setRemarksAsRead(quoteId)
        this.$eventHub.$emit(EventHubTypes.RemarksRead)
      } catch (e) {
        console.error(e)
      }
    },
    async getPlanningPlusActiveStatus() {
      const externalSetting = await CompanySettingService.getCompanyExternalSettings()
      const [planningPlusExternalSetting] = externalSetting.filter( i => i.settingName == ExternalSettingTypes.SETTING_PLANNINGPLUS)
      this.showJobNoteRemarks = parseInt(planningPlusExternalSetting.property5) // Active property
    },
    setPinRemarkOrder(remark) {
      if (this.$licenceExpired) return
      const selectedRemark = this.innerValue.remarks.find(r => r.remarkId == remark.remarkId)
      const pinnedRemarks = this.innerValue.remarks.filter(
        r => r.pinRemarkOrder !== null && r.remarkId !== remark.remarkId)
      if (selectedRemark.pinRemarkOrder == null) {
        selectedRemark.pinRemarkOrder = 0
        for (let remark of pinnedRemarks) {
          remark.pinRemarkOrder += 1
        }
      } else {
        const selectedPinRemarkOrder = selectedRemark.pinRemarkOrder
        selectedRemark.pinRemarkOrder = null
        for (let remark of pinnedRemarks) {
          if (remark.pinRemarkOrder > selectedPinRemarkOrder) {
            remark.pinRemarkOrder -= 1
          }
        }
      }
      this._remarksAutoSaveHelper?.pin([selectedRemark, ...pinnedRemarks])
    },
    addRemarks(remark, printedRemark, jobNoteRemark) {
      if (remark) {
        const newRemark = new RemarkModel(
          this.innerValue.quoteId,
          RemarkTypes.Remark,
          remark,
          this.$userInfo.firstName,
          this.$userInfo.lastName,
          this.$userInfo.displayName,
          this.value.isSyncRepX
        )
        this.innerValue.remarks.splice(this.innerValue.remarks.length, 1, newRemark)
        this.innerValue.remarks.sort(function (a, b) {
          return new Date(b.remarkDateTime) - new Date(a.remarkDateTime)
        })
        this._remarksAutoSaveHelper?.add(newRemark)
      }
      if (printedRemark) {
        const newPrintedRemark = new RemarkModel(
          this.innerValue.quoteId,
          RemarkTypes.PrintedRemark,
          printedRemark,
          this.$userInfo.firstName,
          this.$userInfo.lastName,
          this.$userInfo.displayName
        )
        this.innerValue.printedRemarks.splice(this.innerValue.printedRemarks.length, 1, newPrintedRemark)
        this.innerValue.printedRemarks.sort(function (a, b) {
          return new Date(b.remarkDateTime) - new Date(a.remarkDateTime)
        })
        this._remarksAutoSaveHelper?.add(newPrintedRemark)
      }
      if (jobNoteRemark) {
        const newJobNoteRemark = new RemarkModel(
          this.innerValue.quoteId,
          RemarkTypes.JobNote,
          jobNoteRemark,
          this.$userInfo.firstName,
          this.$userInfo.lastName,
          this.$userInfo.displayName
        )
        this.innerValue.jobNoteRemarks.splice(this.innerValue.jobNoteRemarks.length, 1, newJobNoteRemark)
        this.innerValue.jobNoteRemarks.sort(function (a, b) {
          return new Date(b.remarkDateTime) - new Date(a.remarkDateTime)
        })
        this._remarksAutoSaveHelper?.add(newJobNoteRemark)
      }
      this.toggleRemarkModal()
    },
    toggleRemarkModal() {
      if (this.$licenceExpired) return
      this.isRemarkModalActive = !this.isRemarkModalActive
    },
    deleteRemark(index, remarkId, remarkType) {
      if (this.$licenceExpired) return
      let deletedRemark
      console.log('remarkType: ', remarkType)
      if (remarkType === RemarkTypes.Remark) {
        deletedRemark = this.activeRemarks.find((r) => r.remarkId == remarkId)
        if (deletedRemark.isNew || this.autoSaveEnabled) {
          const index = this.innerValue.remarks.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.remarks.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      } else if (remarkType === RemarkTypes.PrintedRemark) {
        deletedRemark = this.activePrintedRemarks.find((r) => r.remarkId == remarkId)
        if (deletedRemark.isNew || this.autoSaveEnabled) {
          const index = this.innerValue.printedRemarks.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.printedRemarks.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      } else if (remarkType === RemarkTypes.JobNote) {
        deletedRemark = this.activeJobNoteRemarks.find((r) => r.remarkId == remarkId)
        if (deletedRemark.isNew || this.autoSaveEnabled) {
          const index = this.innerValue.jobNoteRemarks.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.jobNoteRemarks.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      } else if (remarkType === RemarkTypes.DueInNote) {
        deletedRemark = this.activeDueInNotes.find((r) => r.remarkId == remarkId)
        if (deletedRemark.isNew || this.autoSaveEnabled) {
          const index = this.innerValue.dueInNotes.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.dueInNotes.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      } else if (remarkType === RemarkTypes.DueOutNote) {
        deletedRemark = this.activeDueOutNotes.find((r) => r.remarkId == remarkId)
        if (deletedRemark.isNew || this.autoSaveEnabled) {
          const index = this.innerValue.dueOutNotes.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.dueOutNotes.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      } else {
        deletedRemark = this.innerValue.otherRemarks.find((r) => r.remarkId == remarkId)
        if (this.autoSaveEnabled) {
          const index = this.innerValue.otherRemarks.findIndex((r) => r.remarkId === deletedRemark.remarkId)
          this.innerValue.otherRemarks.splice(index, 1)
        } else {
          deletedRemark.isDeleted = true
        }
      }
      this._remarksAutoSaveHelper?.delete(deletedRemark)
    },
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
    },
    onPrintedRemarksPageChange(pageIndex) {
      this.printedFilter.pageIndex = pageIndex
    },
    onJobNoteRemarksPageChange(pageIndex) {
      this.jobFilter.pageIndex = pageIndex
    },
    onOtherRemarksPageChange(pageIndex) {
      this.otherFilter.pageIndex = pageIndex
    },
    onDueInNotePageChange(pageIndex) {
      this.dueInFilter.pageIndex = pageIndex
    },
    onDueOutNotePageChange(pageIndex) {
      this.dueOutFilter.pageIndex = pageIndex
    },
    sort(name, order) {},
    onIncidentNotesTextChange(text) {
      if (!this.innerValue.incidentNotes) {
        this.innerValue.incidentNotes = this._createIncidentNotesRemark()
      }
      this.innerValue.incidentNotes.remarks = text
    },
    onIncidentNotesDateChange(date) {
      if (!this.innerValue.incidentNotes) {
        this.innerValue.incidentNotes = this._createIncidentNotesRemark()
      }
      this.innerValue.incidentNotes.remarkDateTime = date
        ? date.toISOString().split('.')[0] + 'Z'
        : null
    },
    _createIncidentNotesRemark() {
      return {
        remarkId: null,
        remarkTypeId: RemarkTypes.INCNOT,
        assetId: this.innerValue.quoteId,
        remarks: '',
        remarkDateTime: new Date().toISOString().split('.')[0] + 'Z',
        isNew: true
      }
    },
    async onIncidentNotesSave() {
      if (!this.autoSaveEnabled || !this.innerValue.incidentNotes) return
      this.isIncidentNotesSaving = true
      try {
        await this._remarksAutoSaveHelper.saveIncidentNotes(this.innerValue.incidentNotes)
      } catch {
        // swallow — controller already catches internally
      } finally {
        this.isIncidentNotesSaving = false
      }
    },
    editRemark(row, remark) {
      if (this.$licenceExpired) return
      if (this.editRemarkRowNumber === row) {
        // Confirm edit - apply the change
        remark.remarks = this.editRemarkInnerValue
        this.editRemarkRowNumber = -1
        this.editRemarkInnerValue = ''
        this._remarksAutoSaveHelper?.update(remark)
      } else {
        // Start edit - store current value
        this.editRemarkInnerValue = remark.remarks
        this.editRemarkRowNumber = row
      }
      this.editPrintedRemarkRowNumber = -1
    },
    editPrintedRemark(row, remark) {
      if (this.$licenceExpired) return
      if (this.editPrintedRemarkRowNumber === row) {
        // Confirm edit - apply the change
        remark.remarks = this.editPrintedRemarkInnerValue
        this.editPrintedRemarkRowNumber = -1
        this.editPrintedRemarkInnerValue = ''
        this._remarksAutoSaveHelper?.update(remark)
      } else {
        // Start edit - store current value
        this.editPrintedRemarkInnerValue = remark.remarks
        this.editPrintedRemarkRowNumber = row
      }
      this.editRemarkRowNumber = -1
    },
    editJobNoteRemark(row, remark) {
      if (this.$licenceExpired) return
      if (this.editJobNoteRemarkRowNumber === row) {
        // Confirm edit - apply the change
        remark.remarks = this.editJobNoteRemarkInnerValue
        this.editJobNoteRemarkRowNumber = -1
        this.editJobNoteRemarkInnerValue = ''
        this._remarksAutoSaveHelper?.update(remark)
      } else {
        // Start edit - store current value
        this.editJobNoteRemarkInnerValue = remark.remarks
        this.editJobNoteRemarkRowNumber = row
      }
    },
    editDueInNote(row, remark) {
      if (this.$licenceExpired) return
      if (this.editDueInNoteRowNumber === row) {
        // Confirm edit - apply the change
        remark.remarks = this.editDueInNoteInnerValue
        this.editDueInNoteRowNumber = -1
        this.editDueInNoteInnerValue = ''
        this._remarksAutoSaveHelper?.update(remark)
      } else {
        // Start edit - store current value
        this.editDueInNoteInnerValue = remark.remarks
        this.editDueInNoteRowNumber = row
      }
      this.editDueOutNoteRowNumber = -1
    },
    editDueOutNote(row, remark) {
      if (this.$licenceExpired) return
      if (this.editDueOutNoteRowNumber === row) {
        // Confirm edit - apply the change
        remark.remarks = this.editDueOutNoteInnerValue
        this.editDueOutNoteRowNumber = -1
        this.editDueOutNoteInnerValue = ''
        this._remarksAutoSaveHelper?.update(remark)
      } else {
        // Start edit - store current value
        this.editDueOutNoteInnerValue = remark.remarks
        this.editDueOutNoteRowNumber = row
      }
      this.editDueInNoteRowNumber = -1
    },
    cancelEditRemark() {
      this.editRemarkRowNumber = -1
      this.editRemarkInnerValue = ''
    },
    cancelEditPrintedRemark() {
      this.editPrintedRemarkRowNumber = -1
      this.editPrintedRemarkInnerValue = ''
    },
    cancelEditJobNoteRemark() {
      this.editJobNoteRemarkRowNumber = -1
      this.editJobNoteRemarkInnerValue = ''
    },
    cancelEditDueInNote() {
      this.editDueInNoteRowNumber = -1
      this.editDueInNoteInnerValue = ''
    },
    cancelEditDueOutNote() {
      this.editDueOutNoteRowNumber = -1
      this.editDueOutNoteInnerValue = ''
    },
    camelCaseToStartCase(str) {
      return str.replace(/((?<!^)[A-Z](?![A-Z]))(?=\S)/g, ' $1').replace(/^./, (s) => s.toUpperCase())
    },
    startCase(str) {
      return _startCase(str)
    },
    showRemarkTypes(type) {
      if (type === 'PartsCheckRemark') {
        return 'PartsCheck Remark'
      } else {
        return this.startCase(type)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.small-font {
  font-size: 10px;
}
.cell > article.box {
  min-height: 300px;
}
</style>
<style lang="scss">
.quote-remarks-licence-expired .button[disabled]:not(.tooltip) {
  position: relative;
  opacity: 1;
  cursor: not-allowed;

  > .icon {
    opacity: 0.5;
  }

  &:hover::before {
    content: 'Disabled, as your licence has expired';
    position: absolute;
    top: 100%;
    right: 0;
    transform: translateY(0.5rem);
    z-index: 30;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    background: rgba(74, 74, 74, 0.9);
    color: #fff;
    font-size: 0.75rem;
    font-weight: normal;
    white-space: nowrap;
    pointer-events: none;
  }
}
</style>
